import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=14478d13&scoped=true&"
import script from "./PurchaseModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=14478d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14478d13",
  null
  
)

export default component.exports